import { Picker, DatePicker, List } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { formatTimeYMD } from '@utils/util';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './MakeAppointment.less';

let hotel = {
  dateFilter: (dateStr) => {
    var currentTime = getDate().getHours(),
      newDateStr = dateStr;
    if(currentTime < 6){
      var newDate =getDate(getDate(newDateStr).getTime()- 86400000),
        year= newDate.getFullYear(),
        month= (newDate.getMonth() + 1) >= 10 ?newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1),
        date= newDate.getDate() >= 10 ? newDate.getDate() : '0' + newDate.getDate();
        newDateStr = year + '-' + month + '-' + date;
    }
    return newDateStr
  }
}

export default class MakeAppointment extends OfficialPage {
  state = {
    appointmentInfo: {},
    goodsId: '',
    longRangeIndex: 0,
    periodRangeIndex: 0,
    selectedDate: '',
    selectedDateIfBusiness: 0,
    selectedPeriod: '',
    serviceTimeUnit: '',
    unitType: '',
    date: '',
    time: '12:00',
    color: '',
    isHotelService: true
  }

  constructor(props) {
    super(props);
    document.title = '预约';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var goodsId = options.detail,
      franchiseeId = options.franchisee || '',
      unitType = options.param,
      appointmentInfo = {},
      date = new Date(),
      timeObj
    timeObj = {
      year: new Date().getFullYear(),
      month:
        new Date().getMonth() + 1 >= 10
          ? new Date().getMonth() + 1
          : '0' + (new Date().getMonth() + 1),
      date:
        new Date().getDate() >= 10
          ? new Date().getDate()
          : '0' + new Date().getDate(),
      startHours:
        new Date().getHours() + 1 >= 10
          ? new Date().getHours() + 1
          : '0' + (new Date().getHours() + 1),
      endHours:
        new Date().getHours() + 2 >= 10
          ? new Date().getHours() + 2
          : '0' + (new Date().getHours() + 2)
    }
    appointmentInfo['appointmentDay'] = '请先选择预约日期'
    appointmentInfo['appointmentStartDateRange'] = '请先选择起始日期'
    appointmentInfo['appointmentEndDateRange'] = '请先选择起始日期'
    appointmentInfo['serviceLongRange'] = ['1小时']
    appointmentInfo['servicePeriodRange'] = [
      timeObj.startHours + ':00-当日' + timeObj.endHours + ':00'
    ]
    appointmentInfo['intervalStart'] = [
      timeObj.year + '-' + timeObj.month + '-' + timeObj.date
    ]
    this.setData({
      goodsId: goodsId,
      franchiseeId: franchiseeId,
      unitType: unitType,
      appointmentInfo: appointmentInfo
    })
    this.dataInitialName()
  }

  dataInitialName = () => {
    var unitType = this.data.unitType,
      isHotelService = this.data.isHotelService,
      serviceTimeUnit,
      servicePrice,
      unitTime
    if (unitType != 6) {
      switch (unitType) {
        case '1':
          unitTime = '请先选择预约日期'
          servicePrice = '请先选择预约日期'
          break
        case '2':
          unitTime = '请先选择预约日期'
          servicePrice = '请先选择预约日期'
          break
        case '3':
          unitTime = '请先选择起始日期'
          servicePrice = '请先选择起始日期'
          break
      }
      isHotelService = false
    } else {
      unitTime = '请先选择起始日期'
      servicePrice = '请先选择起始日期'
      isHotelService = true
    }
    this.setData({
      'appointmentInfo.serviceLongRange[0]': unitTime,
      'appointmentInfo.servicePrice': servicePrice,
      isHotelService: isHotelService
    })
  }
  dataInitial = () => {
    this.getAppointmentList(
      {
        app_id: app.getAppId(),
        data_id: this.data.goodsId,
        sub_shop_app_id: this.data.franchiseeId,
        ck_id: eaa3f988dc6905c67674e708d0752fc2
      },
      true
    )
  }
  getAppointmentList = (param, initial) => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppAppointment/getAppointmentList',
      data: param,
      success: function (res) {
        var data = {},
          response,
          selectedDay,
          selectedEndDay,
          selectedStartDay,
          serviceTimeUnit,
          response = res.data,
          canSelectTimeLong,
          appointmentInfo = response.appointment_info
        data['color'] = '#F05B10'
        if (initial) {
          switch (res.unit_type) {
            case '1':
              serviceTimeUnit = '分'
              break
            case '2':
              serviceTimeUnit = '小时'
              break
            case '3':
              serviceTimeUnit = '天'
              break
            case '6':
              serviceTimeUnit = '天'
              break
          }
          if (serviceTimeUnit == '天') {
            selectedStartDay =
              response.selected_start_day.substring(0, 4) +
              '-' +
              response.selected_start_day.substring(4, 6) +
              '-' +
              response.selected_start_day.substring(6, 8)
            selectedEndDay =
              response.selected_end_day.substring(0, 4) +
              '-' +
              response.selected_end_day.substring(4, 6) +
              '-' +
              response.selected_end_day.substring(6, 8)
            data['appointmentInfo.appointmentStartDateRange'] = selectedStartDay
            data['appointmentInfo.appointmentEndDateRange'] = selectedEndDay
          } else {
            selectedDay =
              response.selected_day.substring(0, 4) +
              '-' +
              response.selected_day.substring(4, 6) +
              '-' +
              response.selected_day.substring(6, 8)
            function sortArr(a, b) {
              return a - b
            }
            canSelectTimeLong = response.can_select_time_long.sort(sortArr)
            data['appointmentInfo.serviceLongRange'] = canSelectTimeLong
            for (var index in response.can_select_interval) {
              var can_select_interval = response.can_select_interval[
                index
              ].split('-')
              if (response.can_select_interval[index].substring(6, 8) >= 24) {
                var endHours =
                  can_select_interval[1].split(':')[0] - 24 >= 10
                    ? can_select_interval[1].split(':')[0] - 24
                    : '0' + (can_select_interval[1].split(':')[0] - 24)
                response.can_select_interval[index] =
                  can_select_interval[0] +
                  '-' +
                  '次日' +
                  endHours +
                  ':' +
                  can_select_interval[1].split(':')[1]
              } else {
                response.can_select_interval[index] =
                  can_select_interval[0] + '-' + '当日' + can_select_interval[1]
              }
            }
            data['appointmentInfo.servicePeriodRange'] =
              response.can_select_interval
            data['appointmentInfo.appointmentDateRange'] = selectedDay
          }
          data['selectedDate'] = 1
          data['selectedDateIfBusiness'] = 1
          data['serviceTimeUnit'] = serviceTimeUnit
        }
        for (var index in appointmentInfo) {
          var periodInterval = appointmentInfo[index].interval,
            startHours = periodInterval.split('-')[0].split(':')[0],
            startMin = periodInterval.split('-')[0].split(':')[1],
            endHours = periodInterval.split('-')[1].split(':')[0],
            endMin = periodInterval.split('-')[1].split(':')[1],
            startTime =
              startHours >= 24
                ? '次日' + (startHours * 1 - 24) + ':' + startMin
                : '当日' + startHours * 1 + ':' + startMin,
            endTime =
              endHours >= 24
                ? '次日' + (endHours * 1 - 24) + ':' + endMin
                : '当日' + endHours * 1 + ':' + endMin
          appointmentInfo[index].interval = startTime + '-' + endTime
        }
        data['appointmentInfo.servicePeriodList'] = appointmentInfo || ''
        data['appointmentInfo.servicePrice'] =
          response.appointment_price != '0'
            ? response.appointment_price + '元'
            : '免费'
        that.setData(data)
      },
      fail: function (res) {
        console.log(res)
      }
    })
  }
  serviceLongChange = e => {
    var value = this.state.appointmentInfo.serviceLongRange.indexOf(e[0]);
    this.setData({
      longRangeIndex: value
    })
    this.serviceConditionChange()
  }
  setTime = (appointmentTime, timeNum) => {
    var appointmentTimeStr, hours, sec, totalSec, totalTime
    appointmentTimeStr = appointmentTime.split(':')
    hours = appointmentTimeStr[0].replace(/[^0-9]/gi, '')
    sec = appointmentTimeStr[1].replace(/[^0-9]/gi, '')
    totalSec = sec * 1 + timeNum * 1
    sec = totalSec > 59 ? totalSec - Math.floor(totalSec / 60) * 60 : totalSec
    sec = sec > 9 ? sec : '0' + sec
    hours = totalSec > 59 ? Math.floor(totalSec / 60) + hours * 1 : hours
    totalTime = hours + ':' + sec
    return totalTime
  }
  bindDateAppointmentChange = date => {
    var date = formatTimeYMD(date, 'YYYY-MM-DD'),
      servicePeriodRange = this.data.appointmentInfo.servicePeriodRange[
        this.data.periodRangeIndex
      ],
      interval,
      startTime,
      timeLong
    this.setData({
      'appointmentInfo.appointmentDay': date
    })
    if (this.data.appointmentInfo.servicePrice != '?') {
      var str = servicePeriodRange.split('-')
      if (
        this.data.unitType == 2 &&
        this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期'
      ) {
        interval =
          str[1].substring(0, 2) == '当日'
            ? str[0] + '-' + str[1].substring(2)
            : str[0] +
            '-' +
            (parseInt(str[1].substring(2, 4)) + 24) +
            str[1].substring(4)
      } else if (
        this.data.unitType == 1 &&
        this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期'
      ) {
        startTime = this.data.time
      }
      if (this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期') {
        timeLong = this.data.appointmentInfo.serviceLongRange[
          this.data.longRangeIndex
        ]
      }
    }
    this.getAppointmentList(
      {
        day: this.data.appointmentInfo.appointmentDay.split('-').join(''),
        app_id: app.getAppId(),
        data_id: this.data.goodsId,
        interval: interval ? interval : '',
        start_time: startTime ? startTime : '',
        time_long: timeLong ? timeLong : '',
        sub_shop_app_id: this.data.franchiseeId
      },
      true
    )
  }
  bindStartDateChange = e => {
    var value = formatTimeYMD(e, 'YYYY-MM-DD'),
      endValueStamp = this.data.isHotelService
        ? new Date(value).getTime() + 86400000
        : new Date(value).getTime(),
      endValue = this.timestampToTime(endValueStamp)
    this.setData({
      'appointmentInfo.appointmentStartDateRange': value,
      'appointmentInfo.appointmentEndDateRange': endValue
    })
    this.getAppointmentList(
      {
        start_date: value.split('-').join(''),
        end_date: this.data.appointmentInfo.appointmentEndDateRange
          .split('-')
          .join(''),
        app_id: app.getAppId(),
        data_id: this.data.goodsId,
        sub_shop_app_id: this.data.franchiseeId
      },
      true
    )
  }
  bindEndDateChange = e => {
    var value = formatTimeYMD(e, 'YYYY-MM-DD'),
      endValueStamp = new Date(value).getTime(),
      startValueStamp = new Date(
        this.data.appointmentInfo.appointmentStartDateRange
      ).getTime()
    if (
      endValueStamp < startValueStamp ||
      (endValueStamp <= startValueStamp && this.data.isHotelService)
    ) {
      app.showModal({
        content: '结束日期有误，请重新选择'
      })
      return false
    }
    this.setData({
      'appointmentInfo.appointmentEndDateRange': value
    })
    this.getAppointmentList(
      {
        start_date: this.data.appointmentInfo.appointmentStartDateRange
          ? this.data.appointmentInfo.appointmentStartDateRange
            .split('-')
            .join('')
          : this.data.appointmentInfo.appointmentDay.split('-').join(''),
        end_date: value.split('-').join(''),
        app_id: app.getAppId(),
        data_id: this.data.goodsId,
        sub_shop_app_id: this.data.franchiseeId
      },
      true
    )
  }
  bindTimeChange = (e, unit) => {
    let value = formatTimeYMD(e, 'hh:mm');
    this.setData({
      time: value
    })
    if (unit == 6) {
      return false
    }
    this.serviceConditionChange()
  }
  servicePeriodSelectChange = e => {
    var value = this.state.appointmentInfo.servicePeriodRange.indexOf(e[0])
    this.setData({
      periodRangeIndex: value
    })
    if (this.data.serviceTimeUnit == '小时') {
      this.serviceConditionChange()
    }
  }
  serviceDateChange = e => {
    var dataset = e.currentTarget.dataset,
      ifBusinessDay = dataset.ifbusinessday,
      date = dataset.date,
      data = {}
    data['selectedDate'] = date
    if (!ifBusinessDay) {
      data['appointmentInfo.servicePeriodList'] = ''
    }
    this.setData(data)
    if (ifBusinessDay) {
      this.serviceConditionChange()
    }
  }
  servicePeriodListChange = e => {
    var dataset = e.currentTarget.dataset,
      canBuy = dataset.canBuy,
      expired = dataset.expired
    if (expired == 1 || canBuy == 0) {
      return
    }
    this.setData({
      selectedPeriod: e.currentTarget.dataset.interval
    })
  }
  serviceConditionChange = () => {
    var param = this.getParam()
    this.getAppointmentList(param, false)
    this.setData({
      selectedPeriod: ''
    })
  }
  hiddeAddToShoppingCart = () => {
    this.setData({
      addToShoppingCartHidden: true
    })
  }
  getParam = () => {
    var appointmentInfo = this.data.appointmentInfo
    if (this.data.appointmentInfo.serviceLongRange) {
      var timeNum = this.data.appointmentInfo.serviceLongRange[0]
    }
    if (appointmentInfo.serviceLongRange) {
      var serviceLongRange =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
    }
    var param = {
      app_id: app.getAppId(),
      data_id: this.data.goodsId,
      sub_shop_app_id: this.data.franchiseeId
    }
    if (this.data.unitType == 2) {
      var periodsSelected =
        appointmentInfo.servicePeriodRange[this.data.periodRangeIndex],
        startDay =
          periodsSelected.substring(6, 8) == '当日'
            ? periodsSelected.split('当日').join('')
            : periodsSelected.substring(0, 6) +
            (periodsSelected.substring(8, 10) * 1 + 24) +
            periodsSelected.substring(10)
      param.interval = startDay
      param.day = this.data.appointmentInfo.appointmentDay.split('-').join('')
      param.time_long =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
    } else if (this.data.unitType == 1) {
      param.day = this.data.appointmentInfo.appointmentDay.split('-').join('')
      param.start_time = this.data.time
      param.time_long =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
    } else if (this.data.unitType == 3) {
      param.start_date = this.data.appointmentInfo.appointmentStartDateRange
        .split('-')
        .join('')
      param.end_date = this.data.appointmentInfo.appointmentEndDateRange
        .split('-')
        .join('')
    }
    return param
  }
  timestampToTime = timestamp => {
    var date = new Date(timestamp)
    var Y = date.getFullYear() + '-'
    var M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-'
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return Y + M + D
  }
  getShopParam = () => {
    var appointmentInfo = this.data.appointmentInfo
    if (this.data.appointmentInfo.serviceLongRange) {
      var timeNum = this.data.appointmentInfo.serviceLongRange[0]
    }
    if (appointmentInfo.serviceLongRange) {
      var serviceLongRange =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
    }
    var param = {
      app_id: app.getAppId(),
      goods_id: this.data.goodsId,
      sub_shop_app_id: this.data.franchiseeId
    }
    if (this.data.serviceTimeUnit == '小时') {
      var startHours = this.data.selectedPeriod.split('-')[0].split(':')[0],
        startHour = startHours.substring(2) * 1,
        startMin = this.data.selectedPeriod.split('-')[0].split(':')[1],
        endHoursLog = this.data.selectedPeriod
          .split('-')[1]
          .split(':')[0]
          .substring(0, 2),
        endHours = parseInt(
          this.data.selectedPeriod
            .split('-')[1]
            .split(':')[0]
            .substring(2)
        ),
        endHours = endHoursLog == '次日' ? endHours + 24 : endHours,
        endMin = this.data.selectedPeriod.split('-')[1].split(':')[1],
        startTime =
          startHours.substring(0, 2) == '当日'
            ? startHour + ':' + startMin
            : startHour + 24 + ':' + startMin,
        endTime =
          endHours < startHour || startTime.split(':')[0] >= 24
            ? endHours + 24 + ':' + endMin
            : endHours + ':' + endMin,
        period = startTime + '-' + endTime
      param.appointment_interval = period
      param.appointment_unit_type = 2
      param.appointment_day = this.data.appointmentInfo.appointmentDay
        .split('-')
        .join('')
      param.appointment_time_long =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
    } else if (this.data.serviceTimeUnit == '分') {
      param.appointment_unit_type = 1
      param.appointment_day = this.data.appointmentInfo.appointmentDay
        .split('-')
        .join('')
      param.appointment_time_long =
        appointmentInfo.serviceLongRange[this.data.longRangeIndex]
      param.appointment_interval =
        this.data.time +
        '-' +
        this.setTime(
          this.data.time,
          appointmentInfo.serviceLongRange[this.data.longRangeIndex]
        )
    } else if (this.data.serviceTimeUnit == '天') {
      if (this.data.unitType == '6') {
        param.appointment_day = this.data.appointmentInfo.appointmentStartDateRange
          .split('-')
          .join('')
      }
      param.appointment_unit_type = this.data.unitType
      param.appointment_start_date = this.data.appointmentInfo.appointmentStartDateRange
        .split('-')
        .join('')
      param.appointment_end_date = this.data.appointmentInfo.appointmentEndDateRange
        .split('-')
        .join('')
    }
    return param
  }
  sureMakeAppointment = e => {
    var selectPeriod = this.data.selectedPeriod,
      franchiseeId = this.data.franchiseeId,
      servicePrice = this.data.appointmentInfo.servicePrice,
      serviceTimeUnit = this.data.serviceTimeUnit,
      param,
      time = this.data.time,
      that = this
    if (!servicePrice) {
      app.showModal({
        content: '该时间段已被预约，请选择其他时间段'
      })
      return
    }
    if (serviceTimeUnit == '小时' && !selectPeriod) {
      app.showModal({
        content: '请选择具体时间'
      })
      return
    }
    param = this.getShopParam()
    param.model_id = 0
    param.num = 1
    param.is_appointment = 1
    app.sendRequest({
      url: '/index.php?r=AppShop/AddCart',
      data: param,
      success: function (res) {
        let cart_arr = [res.data],
          pagePath =
            '/eCommerce/pages/previewAppointmentOrder/previewAppointmentOrder?cart_arr=' +
            encodeURIComponent(cart_arr) +
            ('&to_store=' + JSON.stringify(time))
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        that.hiddeAddToShoppingCart()
        app.turnToPage(pagePath, true)
      }
    })
  }

  render() {
    let {
      showGetUserInfo,
      unitType,
      appointmentInfo,
      color,
      serviceTimeUnit,
      periodRangeIndex,
      appointmentTime,
      time,
      longRangeIndex,
      selectedDate,
      selectedPeriod
    } = this.state

    // 转换Picker组件需要的数据格式
    let periodData = appointmentInfo.servicePeriodRange.map((item) => ({
      label: item,
      value: item
    }));
    let serviceLenData = appointmentInfo.serviceLongRange.map((item) => ({
      label: item + serviceTimeUnit,
      value: item
    }));

    return (
      <div className="official-page make-appointment">
        <TopNav title="预约" />
        <div
          className="appointmentPage-wrap page"
          id="appointmentPage"
          data-router="appointmentPage"
        >
          <div style={convertLineStyleData('position:sticky;')}>
            <div className="appointment-top-section">
              {(serviceTimeUnit == '天' || unitType == 3 || unitType == 6) && (
                <div className="appointment-model-field">
                  <span>起始日期</span>
                  <div className="appointment-model-right">
                    <DatePicker
                      mode="date"
                      extra={appointmentInfo.appointmentStartDateRange}
                      value={
                        unitType == 6
                          ? new Date(hotel.dateFilter(appointmentInfo.intervalStart[0]))
                          : isNaN(new Date(appointmentInfo.appointmentStartDateRange).getTime()) ? null : new Date(appointmentInfo.appointmentStartDateRange)
                      }
                      minDate={
                        unitType == 6
                          ? new Date(hotel.dateFilter(appointmentInfo.intervalStart[0]))
                          : isNaN(new Date(appointmentInfo.intervalStart).getTime()) ? null : new Date(appointmentInfo.intervalStart)
                      }
                      maxDate={new Date('3030-09-01')}
                      onChange={this.bindStartDateChange}
                     >
                      <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                    </DatePicker>
                  </div>
                </div>
              )}
              {(serviceTimeUnit == '天' || unitType == 3 || unitType == 6) && (
                <div className="appointment-model-field">
                  <span>结束日期</span>
                  <div className="appointment-model-right">
                    <DatePicker
                      mode="date"
                      extra={appointmentInfo.appointmentEndDateRange}
                      value={isNaN(new Date(appointmentInfo.appointmentEndDateRange).getTime()) ? null : new Date(appointmentInfo.appointmentEndDateRange)}
                      minDate={new Date(appointmentInfo.intervalStart)}
                      maxDate={new Date('3030-09-01')}
                      onChange={this.bindEndDateChange}
                     >
                      <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                    </DatePicker>
                  </div>
                </div>
              )}
              {(serviceTimeUnit == '分' ||
                serviceTimeUnit == '时' ||
                unitType == 2 ||
                unitType == 1) && (
                  <div className="appointment-model-field">
                    <span>预约日期</span>
                    <div className="appointment-model-right">
                      <DatePicker
                        mode="date"
                        extra={appointmentInfo.appointmentDay}
                        value={isNaN(new Date(appointmentInfo.appointmentDay).getTime()) ? null : new Date(appointmentInfo.appointmentDay)}
                        minDate={new Date(appointmentInfo.intervalStart[0])}
                        maxDate={new Date('3030-09-01')}
                        onChange={this.bindDateAppointmentChange}>
                        <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                      </DatePicker>
                    </div>
                  </div>
                )}
              <div
                className="appointment-model-field"
                hidden={
                  serviceTimeUnit == '天' || unitType == 3 || unitType == 6
                }
              >
                <span>营业时段</span>
                <div className="appointment-model-right">
                  <Picker
                    className="appointment-field-selection"
                    cols={1}
                    data={periodData}
                    value={[periodData[periodRangeIndex].value]}
                    onChange={this.servicePeriodSelectChange}
                  >
                    <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                  </Picker>
                </div>
              </div>
              {(serviceTimeUnit == '天' ||
                serviceTimeUnit == '分' ||
                unitType == 1 ||
                unitType == 3 ||
                unitType == 6) && (
                  <div className="appointment-model-field">
                    <span>预约时间</span>
                    <span style={convertLineStyleData('float:right;')} style={convertLineStyleData('color: ' + color)}>
                      {appointmentTime}
                    </span>
                    <div className="appointment-model-right">
                      <DatePicker
                        className="appointment-field-selection"
                        mode="time"
                        value={new Date('2010-10-10 ' + time)}
                        onChange={(e) => this.bindTimeChange(e, unitType)}
                        >
                        <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                      </DatePicker>
                    </div>
                  </div>
                )}
              <div
                className="appointment-model-field"
                hidden={
                  serviceTimeUnit == '天' || unitType == 3 || unitType == 6
                }
              >
                <span>服务时长</span>
                {/*  <text style={convertLineStyleData('float:right;color:{{color}};')}>{{ serviceTimeUnit }}</text>  */}
                <div className="appointment-model-right">
                  <Picker
                    className="appointment-field-selection"
                    cols={1}
                    extra="请先选择预约日期"
                    data={serviceLenData}
                    value={[serviceLenData[longRangeIndex].value]}
                    onChange={this.serviceLongChange}
                  >
                    <List.Item style={convertLineStyleData('color: ' + color)}></List.Item>
                  </Picker>
                </div>
              </div>
              <div className="appointment-model-field" style={convertLineStyleData('border:none;')}>
                <span>服务价格</span>
                <div className="appointment-model-right">
                  <span
                    className="appointment-service-price"
                    style={convertLineStyleData('color: ' + color)}
                  >
                    {appointmentInfo.servicePrice}
                  </span>
                </div>
              </div>
            </div>
            <div className="appointment-time-section">
              <div className="appointment-date-list">
                {appointmentInfo && appointmentInfo.serviceDateList && appointmentInfo.serviceDateList.map((date, index) => {
                  return (
                    <div
                      key={date.date}
                      className={
                        'appointment-date-item ' +
                        (selectedDate == date.date ? 'selected' : '') +
                        ' ' +
                        (!date.ifBusiness ? 'disabled' : '')
                      }
                      data-date={date.date}
                      data-ifBusinessDay={date.ifBusiness}
                      onClick={this.serviceDateChange}
                    >
                      <div>
                        {date.week}
                        {!date.ifBusiness && <span>(不营业)</span>}
                      </div>
                      <div>{date.modifiedDate}</div>
                    </div>
                  )
                })}
              </div>
              <div className="appointment-period-list">
                {appointmentInfo && appointmentInfo.servicePeriodList && appointmentInfo.servicePeriodList.map((period, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        'appointment-period-item ' +
                        (selectedPeriod == period.interval ? 'selected' : '') +
                        ' ' +
                        (period.can_buy == 0 || period.expired == 1
                          ? 'disabled'
                          : '')
                      }
                      onClick={this.servicePeriodListChange}
                      data-expired={period.expired}
                      data-can-buy={period.can_buy}
                      data-interval={period.interval}
                    >
                      <div>{period.interval}</div>
                      {(period.can_buy == 0 || period.expired == 1) && (
                        <span>
                          {'(' + (period.expired == 1 ? '过期' : '约满') + ')'}
                        </span>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className="appointment-bottom-bar">
            <form>
              <button
                type="button"
                onClick={this.sureMakeAppointment}
                className="btn btn-block sure-make-appointment"
              >
                确认
              </button>
            </form>
            {/*  <text class="btn btn-block sure-make-appointment" bindtap="sureMakeAppointment">zz</text>  */}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/make-appointment/MakeAppointment.jsx